import { DashboardRoutes } from './dashboard/routes';
import { AuthRoutes } from './auth/routes';

export const ModuleRoutes = [...AuthRoutes, ...DashboardRoutes];
